module.exports = __webpack_public_path__ + "static/media/document.26663ece.svg";